// import ...
import React from "react";

const PrivateRoute = ({ component: Component, ...rest }) => {
  return <Component {...rest} />;
};
export default PrivateRoute;
